import React, {FC} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import platformTracking from "@irati-tracking/platform"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"
import {FormattedMessage} from "@irati/utils/lang"

export const Cta: FC<{}> = (props, context) => {
  const {apps} = context

  return (
    <Container wrap="wrap" gap={mainTheme.spacing.two} marginTop={mainTheme.spacing.four} marginBottom={mainTheme.spacing.eight}>
      <ButtonRouterLink
        primary
        large
        app={apps.PERKS}
        to="/account/my-perks/new"
        onClick={() => platformTracking.click("order_history", {source: "redeem_success"})}>
        <FormattedMessage
          id="flexiRewards.merchandise.success.cta.orderHistory" />
      </ButtonRouterLink>

      <ButtonRouterLink large to="/categories">
        <FormattedMessage
          id="flexiRewards.merchandise.success.cta.back" />
      </ButtonRouterLink>
    </Container>
  )
}

const Container = styled(Flex)`
  & > a {
    flex: 1 1 260px
  }
`

Cta.contextTypes = {
  apps: PropTypes.object.isRequired
}
